/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

// include legacy stuff and define global variable for compatibility reasons with messaging module

import {log} from '../utils/log'; // defines globals as side effect ...
log.info("starting messaging module");

import config from "../config";
import {setStorageObject, getStorageObject, deleteStorageObject, getStorageObjectKeys} from "../utils/Storage";
window.setStorageObject = setStorageObject;
window.getStorageObject = getStorageObject;
window.deleteStorageObject = deleteStorageObject;
window.getStorageObjectKeys = getStorageObjectKeys;

import randomInt from "../utils/RandomInt"; // side effect: defines Math.randomInt()

window.registerLinkActionHandler = function () {
	// todo dummy for now
};

import ServerCommunication from "./ServerCommunication";
export default new ServerCommunication(config.updateType);
